<script>import { allow, allowAll, deny, denyAll, isExpired, saveAll } from "../lib/state.js";
import { clearCookies } from "../lib/gtm.js";
import { init } from "../lib/localstorage.js";
import { deserialize, searialize } from "../lib/policy.js";
import { onMount } from "svelte";
import { writable } from "svelte/store";
export let showPopup = false;
export let config = [];
export let database = void 0;
export let domains = [];
const values = {};
const state = writable({});
let cookieDeleter;
const update = (name, allowed) => allowed ? allow(state)(name) : deny(state, cookieDeleter)(name);
onMount(async () => {
  if (database === void 0) {
    database = init("cookies-policy", window);
  }
  cookieDeleter = clearCookies(window)(domains);
  const serializedState = database.load();
  if (serializedState === null) {
    showPopup = true;
  }
  const initialState = {};
  config.forEach((c) => {
    initialState[c.name] = deserialize(c, serializedState ?? {});
    values[c.name] = initialState[c.name].allowed;
    if (initialState[c.name].allowed) {
      initialState[c.name].onAllow();
    }
  });
  state.set(initialState);
  if (isExpired(initialState)) {
    showPopup = true;
  }
  state.subscribe((s) => {
    database?.save(
      Object.fromEntries(
        Object.values(s).map(searialize).map((policy) => [policy.name, policy])
      )
    );
  });
});
</script>

{#if showPopup && Object.keys($state).length > 0}
  {#if $$slots.popup}
    <slot
      name="popup"
      state={$state}
      {update}
      allow={allow(state)}
      deny={deny(state, cookieDeleter)}
      allowAll={allowAll(state)}
      denyAll={denyAll(state, cookieDeleter)}
      saveAll={saveAll(state)}
    />
  {:else}
    {#each Object.keys($state) as name}
      <div>
        <input
          id={name}
          type="checkbox"
          bind:checked={values[name]}
          on:change={() => update(name, values[name])}
        />
        <label for={name}>{name}</label>
      </div>
    {/each}
  {/if}
{/if}
